import useBootstrapData from '@/hooks/useBootstrapData'
import logSearchFormAnalytics from '@/shared-utils/log-search-form-analytics'
import { CruiseSearchForm } from '@pcln/horizon-search-form'
import { handleSubmit as handleCruiseSubmit } from '../SearchForm/utils'

function HorizonCruiseForm() {
  const {
    isMobile,
    referral,
    webstats: { clientGUID: cguid },
  } = useBootstrapData()

  return (
    <CruiseSearchForm
      isMobile={isMobile}
      onSubmit={(data) => {
        handleCruiseSubmit(data, referral, new Date())
        logSearchFormAnalytics({ cguid, pageName: 'homepage', productType: 'cruises', isMobile })
      }}
    />
  )
}

export default HorizonCruiseForm
